import { AlfaBankLogoMIcon } from '@alfalab/icons-logotype';
import { createCn } from 'bem-react-classname';

import './Header.scss';

const cn = createCn('header');

export const Header = () => (
    <header className={cn()}>
        <AlfaBankLogoMIcon className={cn('logo')} color='white' />
    </header>
);
